<template>
    <div v-bind:class="[ (isTouch || isIE) ? 'u-absolute u-fit' : 'u-fixed u-fit-w u-pos-tl u-overflow-h' ]">
        <slot></slot>
        <div v-if="progression" ref="line" class="c-progression u-fixed u-pos-tl u-fit-w"></div>
    </div>
</template>
<script>
    // Reminder: before initialize this component:
    // --------------
    // - Don't forget to add a webfont loader (the line height is different between fonts)
    // - Don't use height auto for image
    //
    // If you don't do that, when the size of page will be calculate, the height risked to be incorrect.

    import { mapState } from 'vuex';
    import getOffsetTop from '@/utilities/getOffsetTop';
    import getPrefix from '@/utilities/getPrefix';

    export default {
        name: 'smoothScroll',

        props: {
            securityCulling: { type: Number, default: 1 },
            toggleVisibility: { type: Boolean, default: true },
            progression: { type: Boolean, default: true },
        },

        computed: {
            ...mapState('window', [
                'height',
                'isTouch',
                'isIE',
            ]),
        },

        watch: {
            $route: 'onRouteChange',
        },

        created() {
            this.$root.scrollTop = 0;
            this.$root.smoothScroll = 0;
            this.cuePoints = [];
            this.$fakeScroll = document.querySelector('.js-fake-scroll');

            this.ratio = 0;
        },

        mounted() {
            document.addEventListener('scroll', this.onScroll, false);

            this.$eventHub.$on('resize', this.resize);
            this.$eventHub.$on('update', this.update);

            this.$eventHub.$on('scrollSection:update', this.setCuePoints);
        },

        beforeDestroy() {
            document.removeEventListener('scroll', this.onScroll);

            this.$eventHub.$off('resize', this.resize);
            this.$eventHub.$off('update', this.update);

            this.$eventHub.$off('scrollSection:update', this.setCuePoints);
        },

        methods: {
            onRouteChange() {
                // Reset scroll val
                window.scrollTo(0, 0);
                this.$root.scrollTop = 0;
                this.$root.smoothScroll = 0;
                this.ratio = 0;
                this.$refs.line.style[getPrefix('transform')] = `scaleX(${this.ratio}) translateZ(0)`;
            },

            onScroll() {
                this.$root.scrollTop = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
            },

            resize() {
                this.containerHeight = this.$el.clientHeight;

                if (this.containerHeight !== this.oldContainerHeight) {
                    this.setPageHeight();
                }

                this.oldContainerHeight = this.containerHeight;

                // ------------

                this.cuePoints.forEach( (section) => {
                    section.size = section.$el.offsetHeight;
                    section.offset = getOffsetTop(section.$el);

                    if(this.isTouch || this.isIE){
                        section.enabled = true;
                    }
                });
            },

            setPageHeight() {
                if (!this.isTouch && !this.isIE) {
                    this.$fakeScroll.style.height = this.containerHeight + 'px';
                } else { // if mobile, transform val
                    this.$fakeScroll.style.height = '0px';

                    for (let i = 0; i < this.NB_CUEPOINTS; i++) {
                        this.cuePoints[i].$el.style[getPrefix('transform')] = 'none';
                    }
                }
            },

            setCuePoints() {
                this.cuePoints = [];

                const sections = Array.from(this.$el.querySelectorAll('.js-section'));

                sections.forEach((el) => {
                    let section = {
                        $el: el,
                        y: 0,
                        size: 0,
                        offset: 0,
                        enabled: false,
                    };

                    this.cuePoints.push(section);
                });

                this.NB_CUEPOINTS = this.cuePoints.length;
            },

            update() {
                this.$root.smoothScroll += ( this.$root.scrollTop - this.$root.smoothScroll ) * 0.1;
                this.$root.smoothScroll = Math.round(this.$root.smoothScroll * 1000) / 1000;

                if (this.isTouch || this.isIE || !this.containerHeight) return;

                for (this.i = 0; this.i < this.NB_CUEPOINTS; this.i++) {
                    this.cuePoints[this.i].y = -this.$root.smoothScroll;

                    if (((this.cuePoints[this.i].y + this.cuePoints[this.i].offset + this.cuePoints[this.i].size) + this.securityCulling < 0
                        || (this.cuePoints[this.i].y + this.cuePoints[this.i].offset - this.height) - this.securityCulling > 0 )) {

                        if (this.cuePoints[this.i].enabled) {
                            if(this.toggleVisibility){
                                this.cuePoints[this.i].$el.style.visibility = 'hidden';
                            }
                            this.cuePoints[this.i].enabled = false;
                            this.cuePoints[this.i].$el.style[getPrefix('transform')] = `translateY(${this.cuePoints[this.i].y}px) translateZ(0)`;
                        }
                    } else {
                        if (!this.cuePoints[this.i].enabled) {
                            if(this.toggleVisibility){
                                this.cuePoints[this.i].$el.style.visibility = 'visible';
                            }
                            this.cuePoints[this.i].enabled = true;
                        }

                        this.cuePoints[this.i].$el.style[getPrefix('transform')] = `translateY(${this.cuePoints[this.i].y}px) translateZ(0)`;
                    }
                }

                if (this.progression && this.containerHeight !== this.height) {
                    this.ratio = this.$root.smoothScroll / (this.containerHeight - this.height);
                    this.ratio = Math.round(this.ratio * 1000) / 1000;
                    this.$refs.line.style[getPrefix('transform')] = `scaleX(${this.ratio}) translateZ(0)`;
                }
            }
        },
    }
</script>

<style lang="stylus">
    @import '../styles/settings/*'

    .c-progression {
        height 4px
        background $colors['white'];

        transform-origin left
        transform scaleX(0) translateZ(0)

        z-index 100
    }
</style>